import React from "react";
import { Stack, Text, depascalize, ensure } from "sprint-common-web";

import { ContentReferenceType } from "../../../../common/types/ContentReferenceType";

type ContentProps = {
    content?: string;
    version?: string;
    contentType?: ContentReferenceType;
};

export function renderContent<T extends ContentProps>(item?: T): JSX.Element {
    ensure(item);

    const { content, version, contentType } = item;

    return (
        <Stack tokens={{ childrenGap: 5 }}>
            {content && <Text variant="smallPlus" value={content} styles={{ root: { fontWeight: "bold" } }} />}
            {version && <Text variant="smallPlus" value={version} />}
            {contentType && (
                <Text variant="smallPlus" value={`Type: ${depascalize(ContentReferenceType[contentType])}`} />
            )}
        </Stack>
    );
}
